import { get, post, patch, del } from './client.js';

const base = (wsId) => `/workspaces/${wsId}/stages`;

export const list = (wsId) => get(base(wsId));
export const create = (wsId, body) => post(base(wsId), body);
export const update = (wsId, stageId, body) => patch(`${base(wsId)}/${stageId}`, body);
export const reorder = (wsId, stages) => post(`${base(wsId)}/reorder`, { stages });
export const remove = (wsId, stageId) => del(`${base(wsId)}/${stageId}`);
